import React from 'react';

import { IconEdit, IconTick } from '@xingternal/icons';
import { usePopOver } from '@xingternal/pop-over';
import { xdlColorDisabled, xdlColorText } from '@xingternal/tokens';

import * as S from './filters.styles';

type Props = {
  disabled?: boolean;
  header: string | JSX.Element;
  options: Record<string, string | JSX.Element>;
  selected: string;
  onOptionClick: (option: string) => void;
};

export const BottomSheetFilter: React.VFC<Props> = ({ disabled, header, options, selected, onOptionClick }) => {
  const { show, togglePopOver } = usePopOver();

  const handleOnOptionClick = (option: string) => () => {
    togglePopOver();
    onOptionClick(option);
  };

  return (
    <>
      <S.ClickableFiltersContainer disabled={disabled} onClick={togglePopOver}>
        <S.FiltersTitleContainer>
          <S.BSFiltersTextContainer>
            <S.FilterHeadline $disabled={disabled} noMargin>
              {header}
            </S.FilterHeadline>
            <S.FilterDescription $disabled={disabled} size="xsmall" noMargin>
              {options[selected]}
            </S.FilterDescription>
          </S.BSFiltersTextContainer>
          <IconEdit width={24} color={disabled ? xdlColorDisabled : xdlColorText} />
        </S.FiltersTitleContainer>
      </S.ClickableFiltersContainer>
      <S.FilterDivider $noMargin />
      <S.BottomSheet show={show} onOutsideClick={togglePopOver} shouldDisableBodyScroll={false} showCloseButton={false}>
        {Object.entries(options).map(([option, text]) => (
          <S.SingleSelect
            key={option}
            onClick={handleOnOptionClick(option)}
            {...(option === selected && { selected: true, icon: IconTick, iconAfter: true })}
          >
            {text}
          </S.SingleSelect>
        ))}
      </S.BottomSheet>
    </>
  );
};
